import { Fragment, useState, useEffect } from 'react';
import ReschedulerModal from '../generic/ReschedulerModal';
import { formatDate } from '../utils/utils';
import {
  getCutoffTimeZoneAbbreviation,
  formatUserFacingCutoffDate,
} from '@hungryroot/datetime';

const ReschedulerUpcoming = ({ getOrder }) => {
  const [modalVisibile, setModalVisibility] = useState(false);
  const [order, setOrder] = useState(null);
  const [showWarningModal, setShowWarningModal] = useState(false);

  useEffect(() => {
    getOrder()
      .then((o) => {
        setOrder(o);
        // TODO: This is a bit of a hack to replace the cutoff date text to one that
        // represents the time in the user's timezone.
        const newCutoffSubtext = `Edit delivery until ${formatUserFacingCutoffDate(
          o.cutoff_date,
          'EEEE, MMM do'
        )} at ${formatUserFacingCutoffDate(
          o.cutoff_date,
          'haaa'
        )} ${getCutoffTimeZoneAbbreviation()}.`;
        document.getElementById('cutoff-subtext').textContent =
          newCutoffSubtext;
      })
      .catch(console.error);
  }, []);

  const setNewOrderSchedule = (_, date, cutoffDate) => {
    setOrder(
      Object.assign({}, order, {
        preferred_date: date,
        cutoff_date: cutoffDate,
      })
    );

    const arrivalDateElement = document.querySelector(
      '#schedule-section .arrival-date'
    );

    if (arrivalDateElement) {
      arrivalDateElement.textContent = `Arriving ${formatDate(date)}`;
    }

    const newCutoffSubtext = `Edit delivery until ${formatUserFacingCutoffDate(
      cutoffDate,
      'EEEE, MMM do'
    )} at ${formatUserFacingCutoffDate(
      cutoffDate,
      'haaa'
    )} ${getCutoffTimeZoneAbbreviation()}.`;
    document.getElementById('cutoff-subtext').textContent = newCutoffSubtext;
  };

  return (
    <Fragment>
      {order && (
        <Fragment>
          {order.sequence !== 1 && (
            <div
              data-testid="skip-delivery"
              className="hr-btn-hol hr-wide manage-calendar-action skip"
              onClick={() => {
                setModalVisibility(true);
                setShowWarningModal(true);
              }}
            >
              Skip Delivery
            </div>
          )}
          <div
            data-testid="reschedule-delivery"
            className="hr-btn-hol hr-wide manage-calendar-action"
            onClick={() => {
              setModalVisibility(true);
              setShowWarningModal(false);
            }}
          >
            Reschedule
          </div>
          <ReschedulerModal
            modalVisible={modalVisibile}
            onModalClose={() => setModalVisibility(false)}
            order={order}
            onSkipOrder={() => (window.location = '/myhungryroot/')}
            onRescheduleOrder={setNewOrderSchedule}
            showWarning={true}
            showWarningModal={showWarningModal}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default ReschedulerUpcoming;
